export const dataStoreSpecInputs = (dataStoreType, datastoreSpec, onChange) => {
  const dataStore =
    datastoreSpec[`${dataStoreType}DatastoreSpec`] ||
    datastoreSpec[`${dataStoreType}DatastoreSpecs`];

  if (!dataStore) {
    return;
  }

  if (dataStoreType === "vmfs") {
    return (
      <cds-form-group layout="horizontal" validate>
      <cds-input layout="horizontal" control-width="shrink">
        <label>Datastore Name</label>
        <input name="datastoreName"
        required
        placeholder="sfo-w01-cl01-ds-fc01"
        value={dataStore.fcSpec[0].datastoreName}
        onChange={onChange}
      />
      <cds-control-message error="valueMissing">required</cds-control-message>
      </cds-input>
      </cds-form-group>
    );
  } else if (dataStoreType === "nfs") {
    return (
      <>
      <cds-form-group layout="horizontal" validate>
      <cds-input layout="horizontal" control-width="shrink">
          <label>Datastore Name</label>
          <input name="datastoreName"
          required
          placeholder="sfo-w01-cl01-ds-nfs01"
          value={dataStore[0].datastoreName}
          onChange={onChange}
        />
        <cds-control-message error="valueMissing">required</cds-control-message>
        </cds-input>
        <cds-input layout="horizontal" control-width="shrink">
          <label>Server IP/Name</label>
          <input name="serverName"
          required
          placeholder="10.0.0.250"
          value={dataStore[0].nasVolume.serverName[0]}
          onChange={onChange}
        />
        <cds-control-message error="valueMissing">required</cds-control-message>
        </cds-input>
        <cds-input layout="horizontal" control-width="shrink">
          <label>Path</label>
          <input name="path"
          required
          placeholder="/nfs_mount/my_read_write_folder"
          value={dataStore[0].nasVolume.path}
          onChange={onChange}
        />
        <cds-control-message error="valueMissing">required</cds-control-message>
        </cds-input>
        </cds-form-group>
      </>
    );
  } else if (dataStoreType === "vvol") {
    return (
      <>
      <cds-form-group layout="horizontal" validate>
        <cds-input layout="horizontal" control-width="shrink">
          <label>Datastore Name</label>
          <input name="name"
          required
          placeholder="sfo-w01-cl01-ds-vvol01"
          value={dataStore[0].name}
          onChange={onChange}
        />
        <cds-control-message error="valueMissing">required</cds-control-message>
        </cds-input>
        <cds-input layout="horizontal" control-width="shrink">
          <label>VASA Provider ID</label>
          <input name="vasaProviderId"
          required
          placeholder="42de6c36-e85e-483b-89c1-4aee5e8deebe"
          value={dataStore[0].vasaProviderSpec.vasaProviderId}
          onChange={onChange}
        />
        <cds-control-message error="valueMissing">required</cds-control-message>
        </cds-input>
        <cds-input layout="horizontal" control-width="shrink">
          <label>Storage Container ID</label>
          <input name="storageContainerId"
          required
          placeholder="908ce3e4-4e8d-414b-84e7-847ba9883521"
          value={dataStore[0].vasaProviderSpec.storageContainerId}
          onChange={onChange}
        />
        <cds-control-message error="valueMissing">required</cds-control-message>
        </cds-input>
        <cds-select control-width="shrink">
        <label>{`Storage Protocol Type`}</label>
          <select
            required
            name="storageProtocolType"
            value={dataStore[0].vasaProviderSpec.storageProtocolType}
            onChange={onChange}
          >
            <option value="" selected>Select</option>
            <option
              value="ISCSI"
              selected={
                dataStore[0].vasaProviderSpec.storageProtocolType === "ISCSI"}>
              ISCSI
            </option>
            <option
              value="VMFS"
              selected={
                dataStore[0].vasaProviderSpec.storageProtocolType === "VMFS"
              }
            >
              VMFS
            </option>
            <option
              value="NFS"
              selected={
                dataStore[0].vasaProviderSpec.storageProtocolType === "NFS"
              }
            >
              NFS
            </option>
            <br />
          </select>
          <cds-control-message error="valueMissing">required</cds-control-message>
          </cds-select>
        <cds-input layout="horizontal" control-width="shrink">
          <label>User ID</label>
          <input name="userId"
          required
          placeholder="d0ed4dd6-1375-4b12-af8c-96c18c46d319"
          value={dataStore[0].vasaProviderSpec.userId}
          onChange={onChange}
        />
        <cds-control-message error="valueMissing">required</cds-control-message>
        </cds-input>
        </cds-form-group>
      </>
    );
  } else if (dataStoreType === "vsan") {
    return (
      <>
      <cds-form-group layout="horizontal" validate>
      <cds-input layout="horizontal" control-width="shrink">
          <label>Datastore Name</label>
          <input name="datastoreName"
          required
          placeholder="sfo-w01-cl01-ds-vsan01"
          value={dataStore.datastoreName}
          onChange={onChange}
        />
        <cds-control-message error="valueMissing">required</cds-control-message>
        </cds-input>
        <cds-select control-width="shrink">
        <label>{`Failures To Tolerate`}</label>
          <select
            name="failuresToTolerate"
            value={dataStore.failuresToTolerate}
            onChange={onChange}
          >
            <option value="0" selected={dataStore.failuresToTolerate === "0"}>
              0
            </option>
            <option value="1" selected={dataStore.failuresToTolerate === "1"}>
              1
            </option>
            <option value="2" selected={dataStore.failuresToTolerate === "2"}>
              2
            </option>
            <br />
          </select>
          </cds-select>
        <cds-input layout="horizontal" control-width="shrink">
          <label>License Key</label>
          <input name="licenseKey"
          required
          placeholder="vsan_license_key"
          value={dataStore.licenseKey}
          onChange={onChange}
        />
        <cds-control-message error="valueMissing">required</cds-control-message>
        </cds-input>
        </cds-form-group>
      </>
    );
  }
};

export const noOfHostToSelectOptions = (startsWith) => {
  const options = [];
  for (let i = startsWith; i <= 32; i++) {
    options.push(<option value={i}>{i}</option>);
  }

  return options;
};

export const nsxTClusterSpecInputs = (ipAddressPoolSpec, onChange) => {
  if (!ipAddressPoolSpec) {
    return;
  }
  if (Object.keys(ipAddressPoolSpec).length === 1) {
    return (
      <cds-input layout="horizontal" control-width="shrink" validate>
        <label>IP Pool Name</label>
        <input name="name"
        required
        placeholder="static-ip-pool-01"
        value={ipAddressPoolSpec.name}
        onChange={onChange}
      />
      <cds-control-message error="valueMissing">required</cds-control-message>
      </cds-input>
    );
  } else {
    return (
      <div className="option_clusterspec_div">
        <cds-form-group layout="horizontal" validate>
        <cds-input layout="horizontal" control-width="shrink">
          <label>IP Pool Name</label>
          <input name="name"
          required
          placeholder="static-ip-pool-01"
          value={ipAddressPoolSpec.name}
          onChange={onChange}
        />
        <cds-control-message error="valueMissing">required</cds-control-message>
        </cds-input>
        <cds-input layout="horizontal" control-width="shrink">
            <label>CIDR</label>
            <input name="cidr"
            required
            placeholder="10.0.11.0/24"
            value={ipAddressPoolSpec.subnets[0].cidr}
            onChange={onChange}
          />
          <cds-control-message error="valueMissing">required</cds-control-message>
          </cds-input>
          <cds-input layout="horizontal" control-width="shrink">
            <label>Gateway</label>
            <input name="gateway"
            required
            placeholder="10.0.11.250"
            pattern="^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])"
            value={ipAddressPoolSpec.subnets[0].gateway}
            onChange={onChange}
          />
          <cds-control-message error="valueMissing">required</cds-control-message>
          </cds-input>
          </cds-form-group>
          <br></br><br></br>
        <div className="option_clusterspec_div">
          <span>IP Address Pool Range</span>
          <br />
          <cds-form-group layout="horizontal" validate>
          <cds-input layout="horizontal" control-width="shrink">
            <label>Start</label>
            <input name="start_0"
            placeholder="10.0.11.50"
            required
            pattern="^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])"
            value={ipAddressPoolSpec.subnets[0].ipAddressPoolRanges[0].start}
            onChange={onChange}
          />
          <cds-control-message error="valueMissing">required</cds-control-message>
          </cds-input>
          <cds-input layout="horizontal" control-width="shrink">
            <label>End</label>
            <input name="end_0"
            placeholder="10.0.11.70"
            required
            pattern="^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])"
            value={ipAddressPoolSpec.subnets[0].ipAddressPoolRanges[0].end}
            onChange={onChange} 
          />
          <cds-control-message error="valueMissing">required</cds-control-message>
          </cds-input>
          </cds-form-group>
          <br></br>
          </div>
         <div>
        </div>
      </div>
    );
  }
};
